<template>
  <div>
    <header>
      <div class="header">
        <div class="order-header-back" >
          <van-icon name="arrow-left" class="i" @click="ListBack"/>
          &nbsp;&nbsp;  
          <span>{{text}}</span>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
    props:['text'],
  data() {
    return {
    };
  },
  methods: {
    //   回退
    ListBack() {
        if (this.text == '补货订单列表' || this.text == '订单列表') {
            this.$router.push('/my')
        }else if(this.text == '订单详情'){
            this.$router.push('/orderList')
        }
        else{
             window.history.back();
        }
    }
  }
};
</script>

<style scoped>
header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10009;
}
.header {
  background: rgba(237, 237, 237, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  position: relative;
  padding-left: 10px;
}

.van-icon-arrow-left {
  top: 2px;
}
</style>